export default __webpack_public_path__ + "static/media/cowpea.43a89d4c.png";